import { trackEvent as coreTrackEvent } from "@structura/core/platform-runtime";

const debounceTimers = new Map<string, ReturnType<typeof setTimeout>>();
const DEBOUNCE_MS = 350;

/** Tracking UI — debounce por evento+tenant para evitar spam. */
export function trackEvent(event: string, meta?: Record<string, unknown>): void {
  coreTrackEvent(event, meta);
  if (typeof window === "undefined") return;
  const tenantKey = String(meta?.tenantId ?? meta?.tenant_id ?? "");
  const key = `${event}:${tenantKey}`;
  const prev = debounceTimers.get(key);
  if (prev) clearTimeout(prev);
  debounceTimers.set(
    key,
    setTimeout(() => {
      debounceTimers.delete(key);
      void fetch("/api/client-telemetry", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ event, meta }),
      }).catch(() => {});
    }, DEBOUNCE_MS),
  );
}
